import React from "react";
import {
  Avatar,
  Box,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  Flex,
  Text,
  useColorMode,
  HStack,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { FiLogOut } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import { useAuth, logout } from "../auth";
import { useGoogleAuth } from "./common/google/GoogleAuthContext";
import { useUser } from "./userRole/UserContext";
import { useOTP } from "./AdminPanelAccess/OTPContext";
import Translate from "./LanguageTranslation/Translate";

const UserProfileMenu = ({
  languageCodeColor,
  userProfileBgColor,
  onLoginClick,
  isScrolled,
}) => {
  const history = useHistory();
  const [logged] = useAuth();
  const { resetOTP } = useOTP();
  const { authState } = useGoogleAuth();
  const { user, loading } = useUser();

  const isUserLoggedIn = logged || authState.isLoggedIn;

  const username = localStorage.getItem("username") || "Guest";
  const email =
    localStorage.getItem("email") || "You are not logged into your account.";

  // Function to get gradient styling based on role
  const getRoleGradient = (userRole) => {
    switch (userRole) {
      case "Creator":
        return {
          bg: "linear-gradient(135deg, #29C836 0%, #1FB832 25%, #15A830 50%, #0B982E 75%, #027334 100%)",
          borderColor: "transparent",
          textColor: "#027334",
          padding: "3px",
        };
      case "Business":
        return {
          bg: "linear-gradient(135deg, #9E7E53 0%, #8A6F4A 25%, #766041 50%, #625138 75%, #5F4017 100%)",
          borderColor: "transparent",
          textColor: "#5F4017",
          padding: "3px",
        };
      default:
        return {
          bg: "transparent",
          borderColor: "black",
          textColor: "black",
        };
    }
  };

  const role = user ? user.role : null;
  const roleGradient = getRoleGradient(role);

  const logoutAndClear = () => {
    logout();
    const keysToRemove = [
      "username",
      "email",
      "perPage",
      "perPageFilter",
      "nPXg",
      "chat_messages",
      "conversation_id",
      "OTP_TOKEN,",
      "profilepic",
      "selectedTab",
      "selectedTripPackingList",
      "selectedTripBudgetPlanner",
      "selectedCause",
    ];
    keysToRemove.forEach((key) => localStorage.removeItem(key));
    resetOTP();
    // history.push("/login");
  };

  return (
    <Flex align="center">
      {/* <Avatar
        name={username}
        src="https://bit.ly/broken-link"
        cursor="pointer"
        size="sm"
        mr={0}
      /> */}
      <Menu _hover="none" _focus="none">
        <MenuButton
          as={Button}
          bg="transparent"
          _hover="none"
          _active="none"
          _focus="none"
          // rightIcon={<ChevronDownIcon />}
          borderRadius="full"
          size={{ base: "xs", md: "xs", lg: "sm" }}
          fontSize={{ base: "xs", md: "sm", lg: "sm" }}
          p={2}
        >
          <HStack>
            <Box bg={roleGradient.bg} borderRadius="lg" p="3px">
              <Avatar
                name={username}
                src="https://bit.ly/broken-link"
                size="sm"
                bg="white"
                borderRadius="lg"
                color={roleGradient.textColor}
                cursor="pointer"
                mr={0}
                textAlign="center"
                border={
                  roleGradient.borderColor !== "transparent"
                    ? `1px solid ${roleGradient.borderColor}`
                    : "none"
                }
              />
            </Box>
          </HStack>
        </MenuButton>
        <MenuList borderRadius="lg" boxShadow="lg" p={2}>
          <Box textAlign="center" p={4} pb={0}>
            <Flex>
              <Box bg={roleGradient.bg} borderRadius="lg" p="3px">
                <Avatar
                  name={username}
                  src="https://bit.ly/broken-link"
                  size="lg"
                  borderRadius="lg"
                  bg="white"
                  color={roleGradient.textColor}
                  border={
                    roleGradient.borderColor !== "transparent"
                      ? `2px solid ${roleGradient.borderColor}`
                      : "none"
                  }
                  // mb={2}
                />
              </Box>
              <Box ml={4} align="left" pt={2} pb={2}>
                <Text fontWeight="bold" mb={0}>
                  {username}
                </Text>
                <Text fontSize="xs" color="gray.500">
                  {email}
                </Text>
              </Box>
            </Flex>
          </Box>
          <MenuDivider />
          {logged ? (
            <MenuItem
              onClick={logoutAndClear}
              icon={<FiLogOut />}
              borderRadius="md"
              _hover={{ bg: "gray.100" }}
              _focus={{ bg: "gray.100" }}
            >
              <Translate text="Logout" />
            </MenuItem>
          ) : (
            <MenuItem
              onClick={onLoginClick}
              icon={<FiLogOut />}
              borderRadius="md"
              _hover={{ bg: "gray.100" }}
              _focus={{ bg: "gray.100" }}
            >
              <Translate text="Login" />
            </MenuItem>
          )}
        </MenuList>
      </Menu>
    </Flex>
  );
};

export default UserProfileMenu;
